export enum PasswordLogInActionTypes {
  INPUT_PASSWORD = 'INPUT_PASSWORD',
  LOGIN_PASSWORD_SUBMIT = 'LOGIN_PASSWORD_SUBMIT',
  RESET_STATE = 'LOGIN_RESET_STATE',
}

interface PasswordLogInPassword {
  type: PasswordLogInActionTypes.INPUT_PASSWORD;
  payload: string;
}

interface PasswordLogInSubmit {
  type: PasswordLogInActionTypes.LOGIN_PASSWORD_SUBMIT;
  errorMessage: string | null;
  passwordValue: string;
}

interface LogInResetState {
  type: PasswordLogInActionTypes.RESET_STATE;
}

export function setLogInPassword(payload: string): PasswordLogInPassword {
  return {
    type: PasswordLogInActionTypes.INPUT_PASSWORD,
    payload,
  };
}

export function setLogInSubmitPassword(
  errorMessage: string | null,
  passwordValue: string,
): PasswordLogInSubmit {
  return {
    type: PasswordLogInActionTypes.LOGIN_PASSWORD_SUBMIT,
    errorMessage,
    passwordValue,
  };
}

export function setLogInResetState(): LogInResetState {
  return {
    type: PasswordLogInActionTypes.RESET_STATE,
  };
}

export type PasswordLogInActions = PasswordLogInPassword | PasswordLogInSubmit | LogInResetState;
